// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App container */
.App_app__gQuxZ {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #1e1e1e;
  color: white;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Main content area */
.App_mainContent__2L8cj {
  flex: 1 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  transition: max-width 0.3s ease;
  box-sizing: border-box;
  position: relative;
}

/* Special styling for template screen - wider layout */
.App_templateWide__zmcC2 {
  max-width: 1400px;
}

@media (max-width: 768px) {
  .App_mainContent__2L8cj {
    padding: 15px;
  }
  
  .App_templateWide__zmcC2 {
    max-width: 100%;
  }
}

/* Button styles */
.App_button__o6-ed {
  background-color: #6366f1;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.App_button__o6-ed:hover {
  background-color: #4f46e5;
}

.App_button__o6-ed:disabled {
  background-color: #2a2a2a;
  color: #666;
  cursor: not-allowed;
}

.App_buttonSecondary__3\\+ArN {
  background-color: transparent;
  border: 1px solid #6366f1;
  color: #6366f1;
}

.App_buttonSecondary__3\\+ArN:hover {
  background-color: rgba(99, 102, 241, 0.1);
}

/* Form element styles */
.App_input__eB\\+wk,
.App_textarea__MqiLX {
  width: 100%;
  padding: 12px;
  background-color: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  margin-bottom: 16px;
  outline: none;
  transition: border-color 0.2s;
}

.App_input__eB\\+wk:focus,
.App_textarea__MqiLX:focus {
  border-color: #6366f1;
}

.App_textarea__MqiLX {
  resize: vertical;
  min-height: 100px;
  line-height: 1.5;
}

/* Card component styles */
.App_card__Uzngl {
  background-color: #2a2a2a;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.App_cardTitle__HTYYV {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  color: white;
}

/* Loading states */
.App_loading__OPBFu {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

/* Error states */
.App_error__mUCnf {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.1);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
}

/* Success states */
.App_success__TrmeY {
  color: #10b981;
  background-color: rgba(16, 185, 129, 0.1);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
} `, "",{"version":3,"sources":["webpack://./src/app/App.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* App container */\n.app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #1e1e1e;\n  color: white;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Main content area */\n.mainContent {\n  flex: 1;\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  transition: max-width 0.3s ease;\n  box-sizing: border-box;\n  position: relative;\n}\n\n/* Special styling for template screen - wider layout */\n.templateWide {\n  max-width: 1400px;\n}\n\n@media (max-width: 768px) {\n  .mainContent {\n    padding: 15px;\n  }\n  \n  .templateWide {\n    max-width: 100%;\n  }\n}\n\n/* Button styles */\n.button {\n  background-color: #6366f1;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.button:hover {\n  background-color: #4f46e5;\n}\n\n.button:disabled {\n  background-color: #2a2a2a;\n  color: #666;\n  cursor: not-allowed;\n}\n\n.buttonSecondary {\n  background-color: transparent;\n  border: 1px solid #6366f1;\n  color: #6366f1;\n}\n\n.buttonSecondary:hover {\n  background-color: rgba(99, 102, 241, 0.1);\n}\n\n/* Form element styles */\n.input,\n.textarea {\n  width: 100%;\n  padding: 12px;\n  background-color: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  margin-bottom: 16px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.input:focus,\n.textarea:focus {\n  border-color: #6366f1;\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 100px;\n  line-height: 1.5;\n}\n\n/* Card component styles */\n.card {\n  background-color: #2a2a2a;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.cardTitle {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 16px;\n  color: white;\n}\n\n/* Loading states */\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n/* Error states */\n.error {\n  color: #ef4444;\n  background-color: rgba(239, 68, 68, 0.1);\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n/* Success states */\n.success {\n  color: #10b981;\n  background-color: rgba(16, 185, 129, 0.1);\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `App_app__gQuxZ`,
	"mainContent": `App_mainContent__2L8cj`,
	"templateWide": `App_templateWide__zmcC2`,
	"button": `App_button__o6-ed`,
	"buttonSecondary": `App_buttonSecondary__3+ArN`,
	"input": `App_input__eB+wk`,
	"textarea": `App_textarea__MqiLX`,
	"card": `App_card__Uzngl`,
	"cardTitle": `App_cardTitle__HTYYV`,
	"loading": `App_loading__OPBFu`,
	"error": `App_error__mUCnf`,
	"success": `App_success__TrmeY`
};
export default ___CSS_LOADER_EXPORT___;
